import type { ComponentType, ReactNode } from 'react';
import { useEffect, useState } from 'react';
import type { RichTextInputProps } from './RichTextInput';
import styles from './RichTextInput.lazy.module.scss';
import { SpinnerIcon } from 'common/components/SpinnerIcon';

export function LazyRichTextInput(props: RichTextInputProps): ReactNode {
  const [RichTextInput, setRichTextInput] =
    useState<null | ComponentType<RichTextInputProps>>(null);

  useEffect(() => {
    import('./RichTextInput').then(mod => {
      setRichTextInput(() => mod.RichTextInput);
    });
  }, []);

  if (RichTextInput) {
    return <RichTextInput {...props} />;
  } else {
    return (
      <div className={styles.loading}>
        <SpinnerIcon />
      </div>
    );
  }
}

export {
  Toolbar,
  ToolbarFormatGroup,
  ToolbarButton,
  ToolbarButtonLink,
  ToolbarSeparator
} from './Toolbar';
